// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// CSV-/JSON-Export, portiert aus docs/referenz/trainingslog.html (Z. 535–552)
import type { WorkoutEntry, Feel } from "./types"
import { volume } from "./sets"
import { dayOf } from "./dates"
import { toast } from "./toast"

const FEEL_EMOJI: Record<Feel, string> = { stark: "💪", gut: "🙂", okay: "😐", zäh: "😮‍💨", schmerz: "🤕" }

/** Dezimalpunkt → Komma (Excel de-DE). */
const dec = (v: number | string): string => String(v).replace(".", ",")

/** CSV-Text wie im Prototyp: BOM, Semikolon, Anführungszeichen verdoppelt. */
export function buildCsv(entries: WorkoutEntry[], exerciseNameById: Map<string, string>): string {
  const maxSets = Math.max(3, ...entries.map((e) => (e.sets ?? []).length))
  const head = ["Datum", "Tag", "Übung"]
  for (let i = 1; i <= maxSets; i++) head.push(`Satz ${i} Wdh.`, `Satz ${i} kg`)
  head.push("Volumen (kg)", "Gefühl", "Notiz")
  const rows = entries.map((e) => {
    const sets = e.sets ?? []
    const r: Array<string | number> = [dayOf(e.date), e.day_code, exerciseNameById.get(e.exercise) ?? e.exercise]
    for (let i = 0; i < maxSets; i++) r.push(sets[i]?.reps ?? "", dec(sets[i]?.weight_kg ?? ""))
    r.push(dec(volume(sets)), FEEL_EMOJI[e.feel] ?? e.feel, e.note || "")
    return r.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(";")
  })
  return "\uFEFF" + head.join(";") + "\n" + rows.join("\n")
}

/** Backup-JSON: Zeitstempel + alle Einträge, hübsch formatiert. */
export function buildJson(entries: WorkoutEntry[]): string {
  return JSON.stringify({ exported: new Date().toISOString(), entries }, null, 2)
}

export function download(name: string, text: string, type: string): void {
  const a = document.createElement("a")
  a.href = URL.createObjectURL(new Blob([text], { type }))
  a.download = name
  a.click()
  URL.revokeObjectURL(a.href)
}

export function exportCsv(entries: WorkoutEntry[], exerciseNameById: Map<string, string>): void {
  download("trainingslog.csv", buildCsv(entries, exerciseNameById), "text/csv;charset=utf-8")
  toast("CSV exportiert – direkt in Excel zu öffnen")
}

export function exportJson(entries: WorkoutEntry[]): void {
  download("fithub-backup.json", buildJson(entries), "application/json")
  toast("Backup exportiert")
}
